// ===== COMPONENTE: BOLHA DE MENSAGEM =====

import React from "react";
import { Bot, User } from "lucide-react";
import type { Message } from "../types";

interface MessageBubbleProps {
  message: Message;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  return (
    <div
      className={`flex gap-2 sm:gap-3 ${
        message.role === "user" ? "flex-row-reverse" : ""
      }`}
    >
      <div
        className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shrink-0"
        style={{
          backgroundColor:
            message.role === "user"
              ? "var(--primary-color)"
              : "var(--primary-color)",
        }}
      >
        {message.role === "user" ? (
          <User className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        ) : (
          <Bot className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        )}
      </div>
      <div className={`flex-1 ${message.role === "user" ? "text-right" : ""}`}>
        <div
          className="inline-block max-w-[85%] sm:max-w-[80%] rounded-2xl px-3 py-2 sm:px-4 sm:py-3 shadow-md border"
          style={{
            backgroundColor:
              message.role === "user"
                ? "var(--primary-color)"
                : "var(--card-bg)",
            color: message.role === "user" ? "#ffffff" : "var(--text-primary)",
            borderColor:
              message.role === "user" ? "transparent" : "var(--border-color)",
            borderTopLeftRadius: message.role === "user" ? "16px" : "4px",
            borderTopRightRadius: message.role === "user" ? "4px" : "16px",
          }}
        >
          <div className="whitespace-pre-wrap text-sm leading-relaxed">
            {message.content.split("\n").map((line, i) => (
              <p key={i} className={i > 0 ? "mt-2" : ""}>
                {line}
              </p>
            ))}
          </div>
          {message.metadata?.apiCalls && (
            <div
              className="mt-2 pt-2 text-xs opacity-70"
              style={{
                borderTopColor: "var(--border-color)",
                borderTopWidth: "1px",
              }}
            >
              🔗 APIs consultadas: {message.metadata.apiCalls.join(", ")}
            </div>
          )}
        </div>
        <div
          className="text-xs mt-1 px-2"
          style={{ color: "var(--text-tertiary)" }}
        >
          {message.timestamp.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      </div>
    </div>
  );
};
